module.exports = __webpack_public_path__ + "img/UTEAST.ade4bb33.png";